import { isWxMiniProgramWebview } from '@/utils/EnvUtils';
import { JsBridge, messageMethodIsSupport } from '@/utils/JsBridge';

type WxMiniProgramBridge = {
  miniProgram?: {
    navigateBack?: (opts: { delta?: number }) => void;
  };
};

function tryWxMiniProgramNavigateBack(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const wx = (window as Window & { wx?: WxMiniProgramBridge }).wx;
  if (!wx?.miniProgram?.navigateBack) {
    return false;
  }
  try {
    wx.miniProgram.navigateBack({ delta: 1 });
    return true;
  } catch {
    return false;
  }
}

/**
 * 在小程序 web-view、App WebView 或普通浏览器中处理左上角「返回」：
 * 1. 原生 WebView 桥接可用：closeWebview
 * 2. 微信小程序：wx.miniProgram.navigateBack
 * 3. 其它：history.back
 */
export function navigateBackFromEmbedded(): void {
  if (messageMethodIsSupport('closeWebview')) {
    JsBridge.closeWebview({ sourceFrom: 'h5' });
    return;
  }
  if (isWxMiniProgramWebview() && tryWxMiniProgramNavigateBack()) {
    return;
  }
  if (typeof window !== 'undefined' && window.history.length > 1) {
    window.history.back();
    return;
  }
  tryWxMiniProgramNavigateBack();
}
